export default __webpack_public_path__ + "static/media/incomplete-icon-new.3573becb.svg";